// Angular
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

// 3rd Party
import { MonacoEditorModule } from 'ngx-monaco-editor';
import { NgxSpinnerModule } from 'ngx-spinner';

// App Modules
import { AppMaterialModule } from 'src/app/app-material.module';

// App Components
import { DropdownModule } from 'primeng/dropdown';
import { CanDeactivateGuard } from 'src/app/_core/guards/can-deactivate.guard';
import { SharedModule } from 'src/app/_shared/shared.module';
import { PrimeNgModule } from 'src/app/primeng.module';
import { CdmTableModule } from '../cdm-table/cdm-table.module';
import { AddCategoryModalComponent } from './add-category-modal/add-category-modal.component';
import { CategoryDefinitionComponent } from './category-definition.component';
import { CategoryDeltaGridComponent } from './category-delta-grid/category-delta-grid.component';
import { CategoryListComponent } from './category-list/category-list.component';
import { CategoryQueryComponent } from './category-query/category-query.component';
import { CptMappingModalComponent } from './cpt-mapping-modal/cpt-mapping-modal.component';
import { DeleteCategoryModalComponent } from './delete-category-modal/delete-category-modal.component';
import { EditCategoryModalComponent } from './edit-category-modal/edit-category-modal.component';
import { ManualExceptionsGridComponent } from './manual-exceptions-grid/manual-exceptions-grid.component';
import { ManualExceptionsComponent } from './manual-exceptions/manual-exceptions.component';
import { N1QLEditorComponent } from './n1ql-editor/n1ql-editor.component';
import { PreviewModalComponent } from './preview-modal/preview-modal.component';
import { RevertConfirmationModalComponent } from './revert-confirmation-modal/revert-confirmation-modal.component';
import { SideCollapseComponent } from './side-collapse/side-collapse.component';
import { ViewCategoryRulesModalComponent } from './view-category-rules-modal/view-category-rules-modal.component';

@NgModule({
  declarations: [
    AddCategoryModalComponent,
    CategoryDefinitionComponent,
    CategoryDeltaGridComponent,
    CategoryListComponent,
    CategoryQueryComponent,
    CptMappingModalComponent,
    DeleteCategoryModalComponent,
    EditCategoryModalComponent,
    ManualExceptionsComponent,
    ManualExceptionsGridComponent,
    N1QLEditorComponent,
    PreviewModalComponent,
    RevertConfirmationModalComponent,
    SideCollapseComponent,
    ViewCategoryRulesModalComponent
  ],
  imports: [
    AppMaterialModule,
    CdmTableModule,
    CommonModule,
    DropdownModule,
    FormsModule,
    MonacoEditorModule.forRoot(),
    NgxSpinnerModule,
    PrimeNgModule,
    SharedModule
  ],
  providers: [CanDeactivateGuard],
  exports: [CategoryDefinitionComponent, N1QLEditorComponent]
})
export class CategoryDefinitionModule {}
